<template>
  <b-container>
    <div class="vue-form flex">
      <b-row>
        <b-col cols="8">
          <splash-screen
              v-if="state === 'splash'"
              @continue="state = 'form'"
              :call-to-action="formData.callToAction"
              :lottie="lottie"
              :button="formDataBtnLaunch"
          />
          <v-form
              v-if="state === 'form'"
              :questions="formData.questions"
              :buttons="formData.buttons ? formData.buttons : null"
              @complete="handleFormComplete"
          />
        </b-col>
        <b-col>
          <b-card title="Good News!"
                  img-src="@/assets/img/onboarding/nathananderson.png"
                  img-alt="Image"
                  img-top
          >
            <b-card-text>
              Your family will receive a <strong>14-day free trial </strong> of our "close-knit" plan which includes:
            </b-card-text>
            <b-card-text>
              <ul style="text-align: left">
                <li>Real-Time Vital Tracking (Tiles)</li>
                <li>Extended Revision and Snapshot History</li>
                <li>Messaging and Communication</li>
                <li>Shared Calendar</li>
                <li>Increased record and attachments limits</li>
                <li>Notifications</li>
                <li>Priority Support</li>
                <li>Premium Apps for Caregiving Tasks</li>
              </ul>
              Plus (+)  More
            </b-card-text>
            <template #footer>
              <small class="text-muted">
                <b-link @click="handleShareThisOffer">
                Share this offer with other families and earn $$$
                </b-link>
              </small>
            </template>
          </b-card>
        </b-col>
      </b-row>

    </div>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import SplashScreen from "./VueForm/SplashScreen";
import vForm from "./VueForm/Form";
import RecordViews from "@/mixins/RecordViews";

export default {
  props: {
    formData: Object,
    lottie: {
      type: Object,
      default() {
        return {
          src: "assets/lotties/blog-management.json",
          alt: "Standard"
        };
      }
    }
  },
  data() {
    return {
      formDataBtnLaunch: this.formData && this.formData.buttons && this.formData.buttons.launchBtnTxt ?
          this.formData.buttons.launchBtnTxt : 'Start',
      imgSrc:"@/assets/img/onboarding/grandsmaanddaugther.png",
      state: "splash",
      res: null
    };
  },
  mixins: [RecordViews],
  created() {
    axios.get("https://api.ipify.org?format=json").then(res => {
      this.res = res;
    });
  },
  components: {
    SplashScreen,
    vForm
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    })
  },
  methods: {
    handleFormComplete(dataFromForm) {
      //View Cookie Policy
      const sessionId = this.formData.sessionId ? this.formData.sessionId : "session";
      const sessionCookie = this.checkSession(sessionId);
      const formId =this.formData.formId ? this.formData.formId : "default";
      const payload = {
        formId: formId,
        uid: this.user ? this.user.uid : null,
        form:dataFromForm,
        cookie: sessionCookie,
        ip: this.res ? (this.res.data ? this.res.data.ip : this.res) : null
      };

      this.$store.dispatch("user/saveFormResponse", payload)
          .then(() => {
            this.$emit("complete", {
              formId: formId,
              data:dataFromForm
            });
          }).catch(()=>{

      })
    },
    handleShareThisOffer(){
      this.$store.dispatch("user/showNotification", {
        title: "Awesome! We have emailed you instructions",
        description: "Kindly review your email for details on how to engage in our referral program and an explanation of its functioning.",
        variant: "info"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.vue-form {
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__cta {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
}
</style>